import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-number-input/input';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import metadata from 'libphonenumber-js/metadata.full.json';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

// Components
import InputGroupWrapper from '../InputGroup';
import CountrySelectWithIcon from './CountrySelect/CountrySelectWithIcon';

// Utils
import translatable from '../../../utils/propTypes/translatable';
import 'react-phone-number-input/style.css';

const PhoneInput = ({
  placeholder,
  className,
  autoSubmit,
  portal,
  locale,
  ...props
}) => {
  const { form, field } = props;
  const [country, setCountry] = useState(portal);
  const intl = useIntl();

  function handleChange(value) {
    form?.setFieldValue(field.name, value);
    if (autoSubmit) {
      form?.submitForm();
    }
  }

  function handleCountryChange(value) {
    setCountry(value);
    form?.setFieldValue(field.name, null);
  }

  return (
    <div
      className={clsx(
        'flex',
        'form-input',
        'w-full',
        'sm:max-w-315',
        'placeholder-gray-300',
        {
          'form-input-error': props.hasError,
        },
        className
      )}
    >
      <CountrySelectWithIcon
        value={country}
        onChange={handleCountryChange}
        locale={locale}
      />
      <ReactPhoneInput
        className={clsx(
          'w-full',
          'placeholder-gray-300',
          'focus:outline-none',
          className
        )}
        international={false}
        addInternationalOption={false}
        smartCaret={false}
        useNationalFormatForDefaultCountryValue={false}
        displayInitialValueAsLocalNumber={false}
        metadata={metadata}
        defaultCountry={country}
        placeholder={
          placeholder?.id ? intl.formatMessage(placeholder) : placeholder
        }
        data-hj-allow
        {...field}
        value={formatPhoneNumberIntl(field?.value)}
        onChange={handleChange}
      />
    </div>
  );
};

PhoneInput.defaultProps = {
  autoSubmit: false,
  type: 'tel',
};

PhoneInput.propTypes = {
  autoSubmit: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  formik: PropTypes.object,
  handleChange: PropTypes.func,
  hasError: PropTypes.bool,
  id: PropTypes.string,
  isTouched: PropTypes.bool,
  label: translatable,
  locale: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: translatable,
  portal: PropTypes.string,
  type: PropTypes.string,
};

// eslint-disable-next-line
const PhoneInputField = props => (
  <InputGroupWrapper {...props} component={PhoneInput} />
);

export default PhoneInputField;
